
import { useLayoutEffect } from 'react';

const useDocumentTitle = (title) => {
  useLayoutEffect(() => {
    if (title) {
      document.title = title;
    } else {
      document.title = 'Mozartren.dk | The best cleaning company ever';
    }
  }, [title]);
};

export default useDocumentTitle;
 